module.exports = __webpack_public_path__ + "static/img/icon_1.431130b8.png";